const Work = [
    {
        id: 9,
        company: "Synopsys",
        title: "Senior Software Engineer",
        date: "Jul 2023 - Present",
        content: [
            "<b>Core contributor</b> to enterprise-scale products, delivering <b>high-impact performance</b> and scalability improvements",
            "<b>Owned</b> end-to-end development of multiple features, including design, implementation, optimization, and production-grade testing",
            "Led <b>performance analysis</b> and optimization initiatives, achieving up to <b>30× runtime improvements</b> and significant memory reductions across modules",
            "Prototyped <b>AI-driven integrations</b> to enable intelligent automation and deeper analytics within the workflow",
            "Technologies: <b>C++, Python, Linux, Git, CI/CD, Bash, Unit Testing</b>"
        ],
        img_link: require('../img/companyLogos/syslogo.jpg'),
        link: '/'
    },
    {
        id: 20,
        company: "Ansys",
        title: "R&D Engineer Intern",
        date: "Aug 2022 - Jun 2023",
        content: ["Researched in optimizing compilation times for core Ansys tools", "<b>Reduced compilation times by 10%</b>, helping developers save time", "Implemented <b>infrastructure optimizations</b> such as gzip-based log compression, reducing log sizes by <b>~80%</b> and lowering per-run storage costs"],
        img_link: require('../img/companyLogos/ansys.png'),
        link: '/'
    },
    {
        id: 23,
        company: "EDC Creative Technologies",
        title: "Software Developer Intern",
        date: "Aug 2021 - Oct 2021",
        content: ["Collaborated with cross-functional teams to <b>develop a web application</b> for an Electric Vehicle Company, and helped increase their online presence and outreach to over <b>10000 users</b> over India",
            "<b>Kickstarted the process</b> of upgrading the entire codebase for a project from <b>ReactJS to NextJS</b>",
            "<b>Links - </b><a href='https://drive.google.com/file/d/18JtG9WL8qI3luQ9c5U-J2b0Ja5dGh-CT/view?usp=sharing' target='_blank'>Certificate of internship</a>"
        ],
        img_link: require('../img/companyLogos/edc.jpg'),
        link: '/'
    },
    {
        id: 30,
        company: "IEDC MEC",
        title: "Front-end Developer",
        date: "Jan 2021 - Jul 2021",
        content: ["Collaborated with teams to build modern and responsive websites for IEDC MEC, the Innovation and Entrepreneurship Cell of Govt. Model Engineering College",
            "<b>Technologies</b> - ReactJS, Firebase, Javascript, HTML, CSS, MaterialUI",
            "<b>Link to sample work - </b><a href='https://iedcmec.in' target='_blank'>IEDC MEC Website</a>"],
        img_link: require('../img/companyLogos/iedc.jpg'),
        link: '/'
    },
    {
        id: 45,
        company: "Excel MEC",
        title: "Web Developer",
        date: "Nov 2020 - Nov 2022",
        content: ["Lead the team in translating designs to efficient code for developing user interfaces for various websites of EXCEL, the national level Tech-fest of Govt. Model Engineering College",
            "<b>Technologies</b> - ReactJS, Javascript, HTML, CSS",
            "<b>Link to sample work - </b><a href='https://vishruth-s.github.io/excel2020marketing/' target='_blank'>Marketing Website</a>"],
        img_link: require('../img/companyLogos/excel.jpg'),
        link: '/'
    }
]

const Education = [
    {
        id: 1,
        company: "Govt. Model Engineering College",
        title: "B.Tech Computer Science",
        date: "Jul 2019 - Jul 2023",
        content: ["Major in Computer Science with basic software subjects like Data Structures, Operating Systems, DBMS, Computer Networks, Automata Theory",
            "Recipient of the prestigious <b>XSA Merit Scholarship</b>, which is given to top 1% of students in college",
            "Received SGPA 10 (Rank 1) in semesters 1, 2, 3 and 4",
            "<b>CGPA: 9.65</b>"],
        img_link: require('../img/companyLogos/mec.jpg'),
        link: '/'
    },
    {
        id: 2,
        company: "Bhavan's Vidya Mandir, Girinagar",
        title: "Higher Secondary",
        date: "Jun 2007 - May 2019",
        content: ["Majored in Physics, Chemistry, Mathematics and Computer Science",
            "Ranked among top 3 in school for AISSCE Board Exam 2019",
            "Extracurricular activities: Science Exhibitions, Quizzes and Presentations",
            "<b>Score: 95.6%</b>"],
        img_link: require('../img/companyLogos/bvmg.png'),
        link: '/'
    },
]

const Volunteering = [
    {
        id: 1,
        company: "TLE MEC",
        title: "Co-founder & Chairperson",
        date: "Sep 2021 - Sep 2022",
        content: ["TLE MEC is a Technical Club of Govt. Model Engineering College with the vision of building a warm and welcoming Competitive Programming culture on our campus so as to help students become better problem solvers by being involved in an active community and discovering the fun in competition."],
        img_link: require('../img/companyLogos/tle.png'),
        link: '/'
    },
    {
        id: 2,
        company: "Codechef MEC Chapter",
        title: "Chapter Lead",
        date: "Aug 2020 - Aug 2021",
        content: ["CodeChef MEC is the Codechef Chapter of Govt. Model Engineering College. It is a community that focuses on building the culture of competitive programming in the campus."],
        img_link: require('../img/companyLogos/codechefmec.jpg'),
        link: '/'
    },
    {
        id: 3,
        company: "Google DSC MEC",
        title: "Core member, Web Team ",
        date: "Jul 2020 - Jul 2021",
        content: ["Google Developer Student Clubs is a community of college and university students interested in Google developer technologies."],
        img_link: require('../img/companyLogos/dscmec.jpg'),
        link: '/'
    },
]

const Expdata = [Education, Work, Volunteering]

export default Expdata
